<template>
  <div>
    <logged-in-header />
    <credits-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import creditsPanel from "../components/credits/CreditsPanel";

export default {
  components: {
    loggedInHeader,
    creditsPanel
  }
};
</script>
